import { Link } from "react-router-dom";

export default function Logo({ dark = false, showText = true, className = "" }) {
  return (
    <Link
      to="/"
      className={`flex items-center gap-3 no-underline ${className}`}
      aria-label="CESMA inicio"
      data-testid="brand-logo"
    >
      <img
        src="/assets/logo-mark.png"
        alt="Logo CESMA: cerebro con caduceo y alas"
        className="h-10 w-auto md:h-11"
        width="44"
        height="40"
      />
      {showText && (
        <span className="leading-none">
          <span
            className={`block font-serif text-[1.45rem] font-semibold tracking-wide ${
              dark ? "text-white" : "text-pine"
            }`}
          >
            CESMA
          </span>
          <span
            className={`mt-[3px] block max-w-[16rem] text-[0.58rem] font-semibold uppercase leading-tight tracking-[0.14em] ${
              dark ? "text-mist/70" : "text-soft"
            }`}
          >
            Especialista en salud mental y adicciones
          </span>
        </span>
      )}
    </Link>
  );
}
